import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/system';
import LoadingButton from '@mui/lab/LoadingButton';
import {Grid, Box, Button} from '@material-ui/core';
import {Select, Checkbox, FormControlLabel, MenuItem, InputLabel, FormControl } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Portal from '@mui/base/Portal';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import InputAdornment from '@mui/material/InputAdornment';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios'; 
import moment from 'moment';
import ContactsSelect from '../contacts/ContactsSelect';
import {API_URL} from '../utils/EnvVars';

const StyledTableCell = styled(TableCell)({
  padding: "3px 0px 3px 5px",
})
const StyledTableCellPdZero = styled(TableCell)({
  padding: 0,
})


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const childRefContacts = React.useRef();
  
  const [loadingBtn, setLoadingBtn] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  const [sgstChk, setSgstChk] = React.useState(true);
  const [igstChk, setIgstChk] = React.useState(false);
  const [discountChk, setDiscountChk] = React.useState(false);
  const [discountType, setDiscountType] = React.useState("%");
  const [unitOfMeasureChk, setUnitOfMeasureChk] = React.useState(false);
  const [inclusiveGSTChk, setInclusiveGSTChk] = React.useState(false);

  const [accountName, setAccountName] = React.useState("");
  const [accountId, setAccountId] = React.useState("");
  const [contactName, setContactName] = React.useState("");
  const [contactId, setContactId] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [billingAddress, setBillingAddress] = React.useState("");

  const [deliveryContactName, setDeliveryContactName] = React.useState("");
  const [deliveryEmail, setDeliveryEmail] = React.useState("");
  const [deliveryMobile, setDeliveryMobile] = React.useState("");
  const [deliveryPhone, setDeliveryPhone] = React.useState("");
  const [deliveryAddress, setDeliveryAddress] = React.useState("");

  const [status, setStatus] = React.useState("Draft");
  const [referenceNumber, setReferenceNumber] = React.useState("");
  const [receivedByAlias, setReceivedByAlias] = React.useState("");
  const [receivedMobile, setReceivedMobile] = React.useState("");
	const [receivingDate, setReceivingDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
	const [expectedPaymentDate, setExpectedPaymentDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
	const [invoiceDate, setInvoiceDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
  const [discountOnTotal, setDiscountOnTotal] = React.useState("");
  const [customerNote, setCustomerNote] = React.useState("");
  const [grandTotal, setGrandTotal] = React.useState(0);


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));

  
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	

    if(props.dataObj && props.dataObj.autoId && props.dataObj.autoId>0){

      if(props.dataObj.sgstOption===1){
        setSgstChk(true);
      }else{
        setSgstChk(false);
      }
      if(props.dataObj.igstOption===1){
        setIgstChk(true);
      }else{
        setIgstChk(false);
      }
      if(props.dataObj.discountOption===1){
        setDiscountChk(true);
      }else{
        setDiscountChk(false);
      }
      if(props.dataObj.uomOption===1){
        setUnitOfMeasureChk(true);
      }else{
        setUnitOfMeasureChk(false);
      }      
      setDiscountType(props.dataObj.discountType);
      setAccountName(props.dataObj.accountName);
      setAccountId(props.dataObj.accountId);
      setContactName(props.dataObj.contactName);
      setContactId(props.dataObj.contactId);
      setMobile(props.dataObj.mobile);
      setEmail(props.dataObj.email);
      setBillingAddress(props.dataObj.billingAddress);
    
      setDeliveryContactName(props.dataObj.deliveryContactName);
      setDeliveryEmail(props.dataObj.deliveryEmail);
      setDeliveryMobile(props.dataObj.deliveryMobile);
      setDeliveryPhone(props.dataObj.deliveryPhone);
      setDeliveryAddress(props.dataObj.deliveryAddress);
    
      setStatus(props.dataObj.status);
      setReferenceNumber(props.dataObj.referenceNumber);
      setReceivedByAlias(props.dataObj.receivedByAlias);
      setReceivedMobile(props.dataObj.receivedMobile);
      setDiscountOnTotal(props.dataObj.discountOnTotal);
      setCustomerNote(props.dataObj.customerNote);
      setGrandTotal(props.dataObj.grandTotalAmount);

      if(props.dataObj.invoiceDate){
        let dateArr = props.dataObj.invoiceDate.split("-");
        setInvoiceDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }
      if(props.dataObj.receivedDate){
        let dateArr = props.dataObj.receivedDate.split("-");
        setReceivingDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }
      if(props.dataObj.expectedPaymentDate){
        let dateArr = props.dataObj.expectedPaymentDate.split("-");
        setExpectedPaymentDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }
    
    }

//      setRows([]);
      if(props.userObj && open){
        getApiDataItems();
      }

	}, [props.dataObj, props.userObj,open]);
  


  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

	function saveData(){
    if(!accountId){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select account");			
      return false;
    }
    if(!contactName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter contact name");			
      return false;
    }
    if(!billingAddress){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter billing address");			
      return false;
    }
    if(email && email.length>0 && !validateEmail(email) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Email is not valid.");			
      return false;
    }
    if(rows && rows.length>0 && rows[0].itemName.length===0){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter item details properly");			
      return false;
    }

		if(accountId && contactName && rows && rows.length>0 && rows[0].itemName.length>0){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId && props.dataObj.autoId>0){
        data.append('id', props.dataObj.autoId);
      }
      data.append('accountId', accountId);
      data.append('accountName', accountName);
      
      if(contactId){
        data.append('contactId', contactId);
      }

      data.append('contactName', contactName);
      data.append('mobile', mobile);
      data.append('email', email); 
      data.append('address', billingAddress); 
    
      data.append('contactNameTwo', deliveryContactName);
      data.append('emailTwo', deliveryEmail);
      data.append('mobileTwo', deliveryMobile);
      data.append('phone', deliveryPhone);
      data.append('addressTwo', deliveryAddress);

      data.append('startDate', moment(invoiceDate).format('YYYY-MM-DD'));
      data.append('endDate', moment(expectedPaymentDate).format('YYYY-MM-DD'));
      data.append('status', status);
      data.append('referenceNumber', referenceNumber);

      data.append('contactNameThree', receivedByAlias);
      data.append('mobileThree', receivedMobile);
      data.append('dateOne', moment(receivingDate).format('YYYY-MM-DD'));

      data.append('jsonDetails', JSON.stringify(rows));

      data.append('discountType', discountType);
      if(discountOnTotal && discountOnTotal>0){
        data.append('discountOnTotal', discountOnTotal);
      }else{
        data.append('discountOnTotal', 0);
      }
      data.append('customerNote', customerNote);
    
      if(sgstChk===true){
        data.append('sgstChk', 1);
      }else{
        data.append('sgstChk', 0);
      }
      if(igstChk===true){
        data.append('igstChk', 1);
      }else{
        data.append('igstChk', 0);
      }
      if(discountChk===true){
        data.append('discountChk', 1);
      }else{
        data.append('discountChk', 0);
      }
      if(unitOfMeasureChk===true){
        data.append('uomChk', 1);
      }else{
        data.append('uomChk', 0);
      }

      if(props.fullList===true){
        data.append('fullList', 1);
      }else{
        data.append('fullList', 0);
      }
          
      setLoadingBtn(true);
			axios.post(API_URL+'/crm-update-invoices', data, axiosHeader)
			.then((response) => {
        setLoadingBtn(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Invoice has been saved.");
          props.updatedList(response.data.list);	
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Invoice could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}


  function selectContacts(){
      childRefContacts.current.handleClickOpen();
	}
  function contactDetail(obj){
    setContactId(obj.autoId);
    setContactName(obj.contactName);
    setAccountId(obj.accountId);
    setAccountName(obj.accountName);
    setMobile(obj.mobile);
    setEmail(obj.email);
    setBillingAddress(obj.address);
  }
  
  function onEnter(event){
		if(event.key === 'Enter'){
			saveData();
		}
	}

  function numberOnly(event){
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    } 
  }
  
  function decimalOnly(event){
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    event.preventDefault();
    return true;
  }

  async function getApiDataItems(){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': props.userObj.registerId,
			'uid': props.userObj.loginId,
			'fullName': props.userObj.fullName,
			'token': props.userObj.token,
		  }
		};

    axios.get(API_URL+'/crm-list-invoices-items?invoiceId='+props.dataObj.autoId, axiosHeader)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){ 
        setRows(response.data.list);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      } 		 				
    }).catch((error) => {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage(""+error);			
      return false;
      })
  }

  const addTableRows = ()=>{
    const rowsInput={
        itemName:'',
        description:'', 
        hsn:'',
        qty:'1',        
        unitPrice:'0',
        uom:'',
        sgst:'0',
        cgst:'0',
        igst:'0',
        discount:'0',
        total:'0'
    } 
    setRows([...rows, rowsInput]);
  }

  const deleteTableRows = (index)=>{
    if(rows && rows.length>1){
      const rdrows = [...rows];
      rdrows.splice(index, 1);
      setRows(rdrows);
    }
  }

  function handleGST(typ,val) {
    if(typ==='igst' && val===true){
      setIgstChk(true);
      setSgstChk(false);
    }else{
      setIgstChk(false);
      setSgstChk(true);
    }    
    handleCalculationAll();
  }



  function handleDiscountChk(val) {
    setDiscountChk(val);
    handleCalculationAll();
  }

  function handleDiscountType (val,event) {
    setDiscountType(val);    
    handleCalculationAll();
  };

  function handleChange(index,event) { 
    const { name, value } = event.target;
    const rowsInput = [...rows];        
    rowsInput[index][name] = value;
    setRows(rowsInput);    
  }

  function handleCalculationInclusiveGST(index) {
    ///Original Cost =  GST Inclusive Price * 100/(100 + GST Rate Percentage)
    const rowsInput = [...rows]; 
    if(inclusiveGSTChk===true){
      if(sgstChk===true && parseInt(rowsInput[index]['sgst'])>0 && parseInt(rowsInput[index]['cgst'])>0 ){
        rowsInput[index]['unitPrice'] = (parseInt(rowsInput[index]['total']) * 100)/(100+parseInt(rowsInput[index]['sgst'])+parseInt(rowsInput[index]['cgst']));

      }else if(igstChk===true && rowsInput[index]['igst']>0){
        rowsInput[index]['unitPrice'] = (parseInt(rowsInput[index]['total']) * 100)/(100+parseInt(rowsInput[index]['igst']));
      }
    }
    setRows(rowsInput);
    grandTotalCalc();
  }

  function handleCalculation(index,namexx) {
    const rowsInput = [...rows]; 

    if(inclusiveGSTChk===true && (namexx==='sgst' || namexx==='cgst' || namexx==='igst' || namexx==='total') && parseInt(rowsInput[index]['total'])>0){
      handleCalculationInclusiveGST(index);
      return false;
    }

    let total = rowsInput[index]['qty'] * rowsInput[index]['unitPrice'];
    if(sgstChk===true && parseInt(rowsInput[index]['sgst'])>0 && parseInt(rowsInput[index]['cgst'])>0 ){
      total = total + (((parseInt(rowsInput[index]['sgst'])+parseInt(rowsInput[index]['cgst']))/100)*total);
    }else if(igstChk===true && rowsInput[index]['igst']>0){
      total = total + ((rowsInput[index]['igst']/100)*total);
    }
    if(discountChk===true && discountType==='%' && parseInt(rowsInput[index]['discount'])>0){
      total = total - ((rowsInput[index]['discount']/100)*total);
    }else if(discountChk===true && discountType==='flat' && parseInt(rowsInput[index]['discount'])>0 && rowsInput[index]['discount']<=total){
      total = total - rowsInput[index]['discount'];
    }else if(discountChk===false){
      rowsInput[index]['discount']=0;
    }    
    rowsInput[index]['total'] = total;
    setRows(rowsInput);
    grandTotalCalc();
  }

  function handleCalculationAll() {
      for(let i in rows){
        handleCalculation(i,'a');
      }
      grandTotalCalc();
  }

  
  function grandTotalCalc() {    
      let gtotal = 0;    
      for(let i in rows){
        gtotal += parseInt(rows[i]['total']);
      }
      if(discountOnTotal && parseInt(discountOnTotal)>0 && parseInt(discountOnTotal)<=parseInt(gtotal) ){
        gtotal = parseInt(gtotal) - parseInt(discountOnTotal);
      }
      setGrandTotal(gtotal);
  }

  return (props.dataObj?
    <>
      <Dialog fullScreen style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>Edit Invoice: {props.dataObj.invoiceNumber}</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} style={{marginRight:15}} >

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>
                          
                          <Grid item md={3} xs={12} >
                            <div>
                              Customer Billing To: 
                            </div>
                              <TextField
                               label="Account Name"
                               onChange={event => setAccountName(event.target.value)}
                               value={accountName}
                               disabled
                               fullWidth
                               size='small'
                               variant="outlined"
                               InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectContacts()}} />
                                  </InputAdornment>
                                ),
                                }}
                               />

                              <TextField size='small' label="Contact Name" onChange={event => setContactName(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={contactName} fullWidth variant="outlined" style={{marginTop: 15}} />
                              <TextField size='small' label="Mobile" onChange={event => setMobile(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={mobile} fullWidth variant="outlined" inputProps={{ maxLength: 10 }} style={{marginTop: 15}} />
                              <TextField size='small' label="Email" onChange={event => setEmail(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={email} fullWidth variant="outlined" style={{marginTop: 15}} />
                              <TextField size='small' label="Address" onChange={event => setBillingAddress(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={billingAddress} fullWidth variant="outlined" style={{marginTop: 15}} />
                            </Grid>    

                            <Grid item md={3} xs={12} >
                            <div>
                              Delivery To: 
                            </div>
                              <TextField size='small' label="Contact Name" onChange={event => setDeliveryContactName(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={deliveryContactName} fullWidth variant="outlined" />
                              <TextField size='small' label="Mobile" onChange={event => setDeliveryMobile(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={deliveryMobile} fullWidth variant="outlined" inputProps={{ maxLength: 10 }} style={{marginTop: 15}} />
                              <TextField size='small' label="Phone" onChange={event => setDeliveryPhone(event.target.value)} value={deliveryPhone} fullWidth variant="outlined" inputProps={{ maxLength: 50 }} style={{marginTop: 15}} />
                              <TextField size='small' label="Email" onChange={event => setDeliveryEmail(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={deliveryEmail} fullWidth variant="outlined" style={{marginTop: 15}} />
                              <TextField size='small' label="Address" onChange={event => setDeliveryAddress(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={deliveryAddress} fullWidth variant="outlined" style={{marginTop: 15}} />
                            </Grid>

                            <Grid item md={3} xs={12} >
                            
                            <TextField 
                                label="Invoice Date"
                                id="date"                                
                                type="date"
                                defaultValue={invoiceDate}
                                fullWidth
                                size="small"
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setInvoiceDate(event.target.value)}
                                variant="outlined"
                                style={{marginTop: 25}}
                                />

                              <TextField 
                                label="Expected Payment Date"
                                id="date"                                
                                type="date"
                                defaultValue={expectedPaymentDate}
                                fullWidth
                                size="small"
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setExpectedPaymentDate(event.target.value)}
                                variant="outlined"
                                style={{marginTop: 15}}
                                />

                            <FormControl fullWidth size='small' style={{marginTop: 15}} >
                              <InputLabel id="demo-simple-select-label">Status</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={status}
                                label="Status"
                                onChange={event => setStatus(event.target.value)}
                              >
                                <MenuItem value={'Draft'}>Draft</MenuItem>
                                <MenuItem value={'Sent'}>Sent</MenuItem>
                                <MenuItem value={'Approved'}>Approved</MenuItem>
                                <MenuItem value={'Paid'}>Paid</MenuItem>
                                <MenuItem value={'Cancelled'}>Cancelled</MenuItem>
                                <MenuItem value={'Refund'}>Refund</MenuItem>
                              </Select>
                            </FormControl>

                            <TextField size='small' label="Reference Number" onChange={event => setReferenceNumber(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={referenceNumber} fullWidth variant="outlined" style={{marginTop: 15}} />

                            

                            </Grid>

                            <Grid item md={3} xs={12} >

                            <TextField size='small' label="Invoice Receiver Name" onChange={event => setReceivedByAlias(event.target.value)} onKeyPress={(event)=>{onEnter(event)}} value={receivedByAlias} fullWidth variant="outlined" style={{marginTop: 25}} />
                            <TextField size='small' label="Invoice Receiver Mobile" onChange={event => setReceivedMobile(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={receivedMobile} fullWidth variant="outlined" inputProps={{ maxLength: 10 }} style={{marginTop: 15}} />

                              <TextField 
                                label="Receiving Date"
                                id="date"                                
                                type="date"
                                defaultValue={receivingDate}
                                fullWidth
                                size="small"
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setReceivingDate(event.target.value)}
                                variant="outlined"
                                style={{marginTop: 15}}
                                />


                            </Grid>

                            <Grid item md={12} xs={12} >                              
                              <FormControlLabel
                                control={
                                  <Checkbox checked={sgstChk} onChange={event => handleGST('sgst',event.target.checked)} />
                                }
                                label="SGST/CGST"
                             />
                             <FormControlLabel
                                control={
                                  <Checkbox checked={igstChk} onChange={event => handleGST('igst',event.target.checked)} />
                                }
                                label="IGST"
                             />
                             <FormControlLabel
                                control={
                                  <Checkbox checked={inclusiveGSTChk} onChange={event => setInclusiveGSTChk(event.target.checked)} />
                                }
                                label="Inclusive GST"
                             />
                             <FormControlLabel
                                control={
                                  <Checkbox checked={discountChk} onChange={event => handleDiscountChk(event.target.checked)} />
                                }
                                label="Discount"
                             />
                             <FormControlLabel
                                control={
                                  <Checkbox checked={unitOfMeasureChk} onChange={event => setUnitOfMeasureChk(event.target.checked)} />
                                }
                                label="Unit Of Measure"
                             />
                             
                             
                             {/* {rows.length} */}
                            <TableContainer component={Paper}>
                                  <Table sx={{ width: '100%', minWidth: 1000 }} size="small" aria-label="simple table">
                                    <TableHead>
                                      <TableRow>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Item</StyledTableCell>            
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Description</StyledTableCell> 
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >HSN/SAC</StyledTableCell>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Qty</StyledTableCell>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Unit Price</StyledTableCell>
                                        {unitOfMeasureChk?
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >UOM</StyledTableCell>
                                        :null}                                        
                                        {sgstChk?<>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >SGST</StyledTableCell> 
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >CGST</StyledTableCell>
                                        </>:null}
                                        {igstChk?
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >IGST</StyledTableCell>
                                        :null}
                                        {discountChk?
                                          <StyledTableCellPdZero style={{paddingLeft:2, verticalAlign:'bottom'}}>
                                                <div style={{margin: 0, padding: 0}}>Discount</div>                                            
                                                <FormControlLabel
                                                    control={
                                                      <Checkbox disableRipple sx={{'& .MuiSvgIcon-root': {fontSize: 15, marginRight:  -1, }, }} checked={discountType==='%'} onClick={event => handleDiscountType('%',event.target.checked)} checkedIcon={<CheckCircleRoundedIcon />} icon={<CircleOutlinedIcon />} />
                                                    }
                                                    label="%"
                                                    sx={{marginRight:1}}
                                                    title="Double Click"
                                                />
                                                <FormControlLabel
                                                    control={
                                                      <Checkbox disableRipple sx={{'& .MuiSvgIcon-root': {fontSize: 15, marginRight:  -1, }, }} checked={discountType==='flat'} onClick={event => handleDiscountType('flat',event.target.checked)} checkedIcon={<CheckCircleRoundedIcon />} icon={<CircleOutlinedIcon />} />
                                                    }
                                                    label="flat"
                                                    title="Double Click"
                                                />
                                          </StyledTableCellPdZero>
                                        :null}                                        
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Total</StyledTableCell> 
                                        <StyledTableCell style={{textAlign:'center'}}>
                                          <i onClick={()=>{addTableRows()}} title="Add New" className="fa fa-plus-circle grnbtncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
                                        </StyledTableCell>           
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {(rows && rows.length>0)?rows.map((row,index) => (
                                        <TableRow
                                          key={row.autoId}
                                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                          <StyledTableCell component="th" scope="row" >
                                              <TextField size='small' name="itemName" value={row.itemName} onChange={event => handleChange(index,event)} fullWidth />
                                          </StyledTableCell>              
                                          <StyledTableCell component="th" scope="row" >
                                            <TextField size='small' name="description" value={row.description} onChange={event => handleChange(index,event)} fullWidth />
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 60}}>
                                            <TextField size='small' name="hsn" value={row.hsn} onChange={event => handleChange(index,event)} fullWidth />
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 60}}>
                                            <TextField size='small' name="qty" value={row.qty} onChange={event => handleChange(index,event)} onBlur={event => handleCalculation(index,'qty')} onKeyPress={(event)=>{numberOnly(event)}} inputProps={{ maxLength: 5 }} fullWidth />
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 100}}>
                                            <TextField size='small' name="unitPrice" value={row.unitPrice} onChange={event => handleChange(index,event)} onBlur={event => handleCalculation(index,'unitPrice')} onKeyPress={(event)=>{decimalOnly(event)}} inputProps={{ maxLength: 8 }} fullWidth />
                                          </StyledTableCell>
                                          {unitOfMeasureChk?
                                          <StyledTableCell style={{width: 60}}>
                                            <TextField size='small' name="uom" value={row.uom} onChange={event => handleChange(index,event)} inputProps={{ maxLength: 50 }} fullWidth />
                                          </StyledTableCell>
                                          :null}
                                          {sgstChk?<>
                                          <StyledTableCell style={{width: 60}} >
                                            <TextField size='small' name="sgst" value={row.sgst} onChange={event => handleChange(index,event)} onBlur={event => handleCalculation(index,'sgst')} onKeyPress={(event)=>{numberOnly(event)}} inputProps={{ maxLength: 2 }} fullWidth />
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 60}} >
                                            <TextField size='small' name="cgst" value={row.cgst} onChange={event => handleChange(index,event)} onBlur={event => handleCalculation(index,'cgst')} onKeyPress={(event)=>{numberOnly(event)}} inputProps={{ maxLength: 2 }} fullWidth />
                                          </StyledTableCell>
                                          </>:null}
                                          {igstChk?
                                          <StyledTableCell style={{width: 60}} >
                                            <TextField size='small' name="igst" value={row.igst} onChange={event => handleChange(index,event)} onBlur={event => handleCalculation(index,'igst')} onKeyPress={(event)=>{numberOnly(event)}} inputProps={{ maxLength: 2 }} fullWidth />
                                          </StyledTableCell>
                                          :null}
                                          {discountChk?
                                          <StyledTableCell style={{width: 81}} >
                                            <TextField size='small' name="discount" value={row.discount} onChange={event => handleChange(index,event)} onBlur={event => handleCalculation(index,'discount')} onKeyPress={(event)=>{numberOnly(event)}} inputProps={{ maxLength: 8 }} fullWidth />
                                          </StyledTableCell>
                                          :null}
                                          <StyledTableCell style={{width: 100}}>
                                            <TextField size='small' name="total" value={row.total} onChange={event => handleChange(index,event)} onBlur={event => handleCalculation(index,'total')} onKeyPress={(event)=>{numberOnly(event)}} inputProps={{ maxLength: 10 }} fullWidth />
                                          </StyledTableCell>
                                          <StyledTableCell align="center" style={{width: 60}} >
                                            {(rows && rows.length>1)?
                                              <i onClick={()=>{ deleteTableRows(index);}} title="Remove" className="fa fa-minus delbtncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
                                            :null}  
                                          </StyledTableCell>
                                        </TableRow>
                                      )):null}

                                        <TableRow
                                          sx={{ '&:last-child td, &:last-child th': { border: 0, paddingTop: 2, paddingBottom: 1 } }}
                                        >
                                          <StyledTableCell component="th" scope="row" colSpan={5} style={{verticalAlign:'top'}} >
                                              <TextField size='small' onChange={event => setCustomerNote(event.target.value)} value={customerNote} label='Customer Note'  variant="outlined" fullWidth multiline InputLabelProps={{shrink: true, }} />
                                          </StyledTableCell> 
                                          {unitOfMeasureChk?
                                          <StyledTableCell style={{width: 60}}>&nbsp;</StyledTableCell>
                                          :null}
                                          {sgstChk?<>
                                          <StyledTableCell style={{width: 60}} >&nbsp;</StyledTableCell>
                                          </>:null}
                                          
                                          {discountChk?
                                          <StyledTableCell colSpan={2} style={{width: 81, verticalAlign:'top'}} >
                                              <TextField size='small' label="Discount Amount on Total" onChange={event => setDiscountOnTotal(event.target.value)} onBlur={()=>{grandTotalCalc()}} value={discountOnTotal} variant="outlined" fullWidth InputLabelProps={{shrink: true, }} />
                                          </StyledTableCell>
                                          :<StyledTableCell style={{width: 81, verticalAlign:'top'}} ></StyledTableCell>}
                                          <StyledTableCell style={{width: 100, verticalAlign:'top'}}>
                                              <TextField disabled label="Grand Total" value={grandTotal} size='small' fullWidth variant="outlined" InputLabelProps={{shrink: true, }} />
                                          </StyledTableCell>
                                          <StyledTableCell align="center" style={{width: 60}} >&nbsp;</StyledTableCell>
                                        </TableRow>


                                    </TableBody>
                                  </Table>
                                </TableContainer>


                            </Grid>

                           

                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {loadingBtn?
                            <LoadingButton
                              loading
                              loadingPosition="start"											
                              variant="outlined"
                              color="secondary"
                              id="waitloginbtnid" 
                              style={{width: 110, backgroundColor:'#008000',color:'#FFF',marginRight:10}}
                            >
                              Wait...
                            </LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }    
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>

        <ContactsSelect userObj={props.userObj} contactDetail={contactDetail} ref={childRefContacts} />
        
    </>
  :null);

});

export default CustomizedDialogs;